import { useMutation, useQuery } from '@tanstack/react-query';
import { store } from '../..';
import { queryClient } from '../../..';
import { setAlert, setIsLoading } from '../../components/components-slice';
import { nhisApis } from './../../../api/payroll/statutory-compliance/nhis';

export function useGetNhisHistory(limit, page, statusFilter, search) {
  return useQuery(
    ['nhis', { limit, page, statusFilter, search }],
    () => {
      store.dispatch(setIsLoading(true));
      return nhisApis.getNHIS({
        limit,
        page,
        statusFilter,
        search,
      });
    },
    {
      select(data) {
        data?.data?.forEach((nhis) => {
          nhis.status = parseFloat(nhis.nhis_status)
          if (nhis.status === 2) {
            nhis.status = 0
          }
          switch (nhis.status) {
            case 0:
              nhis.computedActions = [0];
              break;
            case 1:
              nhis.computedActions = [1];
              break;
            default:
              break;
          }
        });

        return data;
      },
      onSettled: (data, error, variables, context) => {
        store.dispatch(setIsLoading(false));
      },
      // keepPreviousData: true
    },
  );
}

export function useUploadNhis() {
  return useMutation(
    (payload) => {
      return nhisApis.bulkNHIS(payload);
    },
    {
      onSuccess: () => {
        queryClient.invalidateQueries('nhis');
        store.dispatch(setAlert(true, 'success', 'Upload Successful'));
      },
    },
  );
}

export function useRefNHIS(payload) {
  return useQuery(
    ['nhis-by-ref', { payload }],
    () => {
      store.dispatch(setIsLoading(true));
      return nhisApis.fetchNHISByRef(payload);
    },
    {
      select: (data) => {
        // data.data.salaries.data.forEach((item) => {
        //   item.employeeName = `${item.employee_first_name} ${item.employee_last_name}`;
        //   item.net_pay = item.net_pay.toFixed(2);
        //   item.total = (
        //     parseFloat(item.trans_cost) + parseFloat(item.net_pay)
        //   ).toFixed(2);
        // });

        // return data;
      },
      onSettled: (data, error, variables, context) => {
        store.dispatch(setIsLoading(false));
      },
      // keepPreviousData: true
    },
  );
}